export function usePerformanceLogger(_eventName, _dependencyList) {
}
